
export default function ArticlePartTwo() {
  return (
    <section className="mb-16">
      <div className="prose prose-lg max-w-none">
        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border-t-4 border-teal-600">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="bg-teal-600 text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-lg">2</span>
            Local Real Estate Investment Associations (REIAs)
          </h3>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            Real Estate Investment Associations are networking groups where investors meet regularly to share deals, strategies, and resources. El Paso has several active REIAs where you can connect with serious, experienced investors.
          </p>

          <div className="bg-teal-50 p-6 rounded-lg mb-6">
            <h4 className="text-lg font-semibold text-gray-900 mb-3">El Paso Real Estate Investors Association</h4>
            <p className="text-gray-700 leading-relaxed mb-3">
              This group meets monthly and includes fix-and-flip investors, landlords, wholesalers, and real estate professionals. Attending a meeting allows you to pitch your property directly to multiple investors at once. Most REIAs welcome homeowners who are looking to sell.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>How to find them:</strong> Search for "El Paso REIA" on Meetup.com, Facebook, or the National REIA website. Many groups also have email lists where you can submit property details.
            </p>
          </div>

          <div className="space-y-4 ml-4">
            <div className="flex items-start">
              <i className="ri-star-fill text-teal-600 text-xl mr-3 mt-1"></i>
              <div>
                <strong className="text-gray-900">Advantage:</strong>
                <p className="text-gray-700 mt-1">You're connecting with active, local investors who know the El Paso market intimately and have the capital to close quickly.</p>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-alert-fill text-amber-600 text-xl mr-3 mt-1"></i>
              <div>
                <strong className="text-gray-900">Consideration:</strong>
                <p className="text-gray-700 mt-1">You may need to attend a meeting in person or pay a small guest fee. Some groups require you to present your property details in a specific format.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border-t-4 border-teal-600">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="bg-teal-600 text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-lg">3</span>
            Direct Mail and Bandit Signs
          </h3>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            If you've ever seen a "We Buy Houses" sign on a street corner or received a postcard offering to purchase your home, you've encountered investor marketing. While these methods may seem unsolicited, they can be a legitimate way to connect with active buyers.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="bg-gray-50 p-5 rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                <i className="ri-mail-line text-teal-600 mr-2"></i>
                Direct Mail Postcards
              </h4>
              <p className="text-gray-700 leading-relaxed">
                Investors send postcards to homeowners in specific neighborhoods or those facing foreclosure. If you receive one, it means an investor has identified your property as a potential opportunity. Call the number on the postcard to discuss your situation and request an offer.
              </p>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                <i className="ri-road-map-line text-teal-600 mr-2"></i>
                Bandit Signs
              </h4>
              <p className="text-gray-700 leading-relaxed">
                These are the handwritten or printed signs you see at intersections saying "We Buy Houses - Cash" with a phone number. While they may look informal, many legitimate investors use them as a cost-effective marketing tool. Call the number to gauge their professionalism and experience.
              </p>
            </div>
          </div>

          <div className="bg-amber-50 border-l-4 border-amber-500 p-5 rounded-r-lg">
            <p className="text-amber-900 font-semibold mb-2">⚠️ Vetting Tip:</p>
            <p className="text-amber-800 leading-relaxed">
              Before working with any investor you find through direct mail or signs, verify their business license, check online reviews, and ask for references from previous sellers. Legitimate investors will have no problem providing this information.
            </p>
          </div>
        </div>

        <img 
          src="https://public.readdy.ai/ai/img_res/6b0f32afea04f73506acee02bccd321c.jpg"
          alt="We Buy Houses sign in El Paso neighborhood"
          className="w-full h-96 object-cover rounded-xl shadow-lg mb-10"
        />

        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border-t-4 border-teal-600">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="bg-teal-600 text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-lg">4</span>
            Real Estate Agents Who Work with Investors
          </h3>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            Not all real estate agents work exclusively with traditional buyers. Many agents specialize in investment properties and maintain networks of active investors looking for deals. These agents can connect you with pre-vetted buyers and facilitate the transaction.
          </p>

          <div className="space-y-4 ml-4 mb-6">
            <div className="flex items-start">
              <i className="ri-user-star-line text-teal-600 text-xl mr-3 mt-1"></i>
              <div>
                <strong className="text-gray-900">How to Find Them:</strong>
                <p className="text-gray-700 mt-1">Look for agents who advertise "investment property specialist" or "work with cash buyers" in their marketing. You can also call local brokerages and ask if they have agents who focus on investor sales.</p>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-hand-coin-line text-teal-600 text-xl mr-3 mt-1"></i>
              <div>
                <strong className="text-gray-900">Commission Consideration:</strong>
                <p className="text-gray-700 mt-1">Keep in mind that if you list with an agent, you'll typically pay a 5% to 6% commission, which reduces your net proceeds. However, the agent may be able to get you a higher price than you'd receive from a direct investor purchase.</p>
              </div>
            </div>

            <div className="flex items-start">
              <i className="ri-shield-check-line text-teal-600 text-xl mr-3 mt-1"></i>
              <div>
                <strong className="text-gray-900">Added Protection:</strong>
                <p className="text-gray-700 mt-1">Working with a licensed agent provides an extra layer of protection and ensures all paperwork is handled correctly. The agent can also help you evaluate multiple investor offers to ensure you're getting a fair deal.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border-t-4 border-teal-600">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="bg-teal-600 text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-lg">5</span>
            Courthouse and Public Records
          </h3>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            This method requires more effort but can connect you with serious investors. Many investors monitor courthouse records for foreclosure filings, tax liens, and probate cases to find motivated sellers. You can reverse this strategy by identifying investors who are actively buying in your area.
          </p>

          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <h4 className="text-lg font-semibold text-gray-900 mb-4">How to Use Public Records:</h4>
            <ol className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="font-bold text-teal-600 mr-3">1.</span>
                <span>Visit the El Paso County Clerk's office or access their online records portal to search recent property transactions.</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-teal-600 mr-3">2.</span>
                <span>Look for buyers who have purchased multiple properties in a short time frame, especially cash transactions with no mortgage recorded.</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-teal-600 mr-3">3.</span>
                <span>Note the buyer's name and search for their contact information online or through business registration databases.</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-teal-600 mr-3">4.</span>
                <span>Reach out directly via phone or email to introduce your property and gauge their interest.</span>
              </li>
            </ol>
          </div>

          <p className="text-gray-700 leading-relaxed">
            This approach takes time and research, but it allows you to identify investors who are actively buying in your specific neighborhood or property type. You're essentially creating your own list of qualified buyers rather than waiting for them to find you.
          </p>
        </div>

        <img 
          src="https://readdy.ai/api/search-image?query=El%20Paso%20County%20courthouse%20building%20exterior%20with%20American%20and%20Texas%20flags%2C%20official%20government%20architecture%2C%20stone%20columns%20and%20steps%2C%20clear%20sunny%20day%20with%20blue%20sky%2C%20professional%20architectural%20photography%2C%20people%20walking%20on%20sidewalk%2C%20downtown%20El%20Paso%20setting%2C%20realistic%20high%20quality%20image&width=1200&height=600&seq=courthouse-building-004&orientation=landscape"
          alt="El Paso County Courthouse building"
          className="w-full h-96 object-cover rounded-xl shadow-lg mb-10"
        />

        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border-t-4 border-teal-600">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="bg-teal-600 text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-lg">6</span>
            Cash Home Buying Companies
          </h3>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            These are established businesses that specialize in purchasing homes directly from sellers for cash. Unlike individual investors, these companies have systems in place to evaluate properties quickly, make offers within 24 to 48 hours, and close on your timeline.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="bg-teal-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-3">National Companies</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>Opendoor, Offerpad, and RedfinNow operate in select markets and use technology to generate instant offers.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>HomeVestors (We Buy Ugly Houses) has franchises nationwide, including in El Paso.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>These companies offer convenience but may charge service fees or offer below-market prices.</span>
                </li>
              </ul>
            </div>

            <div className="bg-teal-50 p-6 rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Local El Paso Companies</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>Local cash buying companies understand the El Paso market better and may offer more competitive prices.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>They're often more flexible with closing dates and can accommodate unique situations.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-teal-600 mr-2 mt-1"></i>
                  <span>Search for "sell my house fast El Paso" or "cash home buyers El Paso" to find local options.</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-teal-600 text-white p-6 rounded-lg">
            <h4 className="text-xl font-bold mb-3">What to Look for in a Cash Buying Company:</h4>
            <ul className="space-y-2">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-white text-xl mr-2 mt-0.5"></i>
                <span>Established track record with verifiable reviews on Google, BBB, and Trustpilot</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-white text-xl mr-2 mt-0.5"></i>
                <span>Transparent process with no hidden fees or obligations</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-white text-xl mr-2 mt-0.5"></i>
                <span>Licensed and insured with proof of funds to close</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-white text-xl mr-2 mt-0.5"></i>
                <span>Willingness to answer questions and explain their offer in detail</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-line text-white text-xl mr-2 mt-0.5"></i>
                <span>No pressure tactics or demands for upfront fees</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
